import { Box, Grid, CardMedia } from "@mui/material";

const ImageGallery = ({ imageUrls, aspectRatio = "2/1" }) => {
  return (
    <Box sx={{ width: "100%", aspectRatio, overflow: "hidden" }}>
      <Grid container spacing={1} sx={{ height: "100%" }}>
        <Grid item xs={6} sx={{ height: "100%" }}>
          <CardMedia
            component="img"
            sx={{ width: "100%", height: "100%", objectFit: "cover" }}
            image={imageUrls?.[0]}
            alt=""
          />
        </Grid>
        <Grid item xs={6} container direction="column" spacing={1}>
          <Grid item xs={6} container spacing={1}>
            <Grid item xs={6} sx={{ height: "100%" }}>
              <CardMedia
                component="img"
                sx={{ width: "100%", height: "100%", objectFit: "cover" }}
                image={imageUrls?.[1]}
                alt=""
              />
            </Grid>
            <Grid item xs={6} sx={{ height: "100%" }}>
              <CardMedia
                component="img"
                sx={{ width: "100%", height: "100%", objectFit: "cover" }}
                image={imageUrls?.[2]}
                alt=""
              />
            </Grid>
          </Grid>
          <Grid item xs={6} container spacing={1}>
            <Grid item xs={6} sx={{ height: "100%" }}>
              <CardMedia
                component="img"
                sx={{ width: "100%", height: "100%", objectFit: "cover" }}
                image={imageUrls?.[3]}
                alt=""
              />
            </Grid>
            <Grid item xs={6} sx={{ height: "100%" }}>
              <CardMedia
                component="img"
                sx={{ width: "100%", height: "100%", objectFit: "cover" }}
                image={imageUrls?.[4]}
                alt=""
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ImageGallery;
